export default "__VITE_ASSET__DGmyUyqy__"